import { RouteConfig } from "vue-router";
import { UserState } from "@/store/modules/auth/interfaces";

export const syllabi_comparison: RouteConfig = {
  path: "comparison",
  component: () =>
    import("@/views/modules/institute/syllabi_comparison/Wrapper.vue"),
  meta: {
    name: "nav-sidebar.syllabi-comparison",
    icon: require("@/assets/icons/nav_sidebar/active/jobs.svg"),
    user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
  },
  children: [
    {
      path: "",
      redirect: {
        name: "select-operation"
      }
    },
    {
      path: "select",
      name: "select-operation",
      component: () =>
        import(
          "@/views/modules/institute/syllabi_comparison/SelectOperation.vue"
        ),
      meta: {
        name: "nav-sidebar.syllabi-comparison",
        icon: require("@/assets/icons/nav_sidebar/active/jobs.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "national-global",
      name: "national-global-comparison",
      component: () =>
        import(
          "@/views/modules/institute/syllabi_comparison/NationalGlobalComparisonChoice.vue"
        ),
      meta: {
        name: "nav-sidebar.syllabi-comparison",
        icon: require("@/assets/icons/nav_sidebar/active/jobs.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "national-global/result",
      name: "national-global-comparison-result",
      component: () =>
        import(
          "@/views/modules/institute/syllabi_comparison/NationalGlobalComparison.vue"
        ),
      meta: {
        name: "nav-sidebar.syllabi-comparison",
        icon: require("@/assets/icons/nav_sidebar/active/jobs.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "national-global/result/upskill",
      name: "upskill-courses-national-global",
      component: () =>
        import(
          "@/views/modules/institute/syllabi_comparison/UpskillCourses.vue"
        ),
      meta: {
        name: "nav-sidebar.syllabi-comparison",
        icon: require("@/assets/icons/nav_sidebar/active/jobs.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "national-job",
      name: "national-job-comparison",
      component: () =>
        import(
          "@/views/modules/institute/syllabi_comparison/NationalJobComparisonChoice.vue"
        ),
      meta: {
        name: "nav-sidebar.syllabi-comparison",
        icon: require("@/assets/icons/nav_sidebar/active/jobs.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "national-job/result",
      name: "national-job-comparison-result",
      component: () =>
        import(
          "@/views/modules/institute/syllabi_comparison/NationalJobComparison.vue"
        ),
      meta: {
        name: "nav-sidebar.syllabi-comparison",
        icon: require("@/assets/icons/nav_sidebar/active/jobs.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "national-job/result/upskill",
      name: "upskill-courses-national-job",
      component: () =>
        import(
          "@/views/modules/institute/syllabi_comparison/UpskillCourses.vue"
        ),
      meta: {
        name: "nav-sidebar.syllabi-comparison",
        icon: require("@/assets/icons/nav_sidebar/active/jobs.svg"),
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    }
  ]
};
